/**
 * 打印模板模块 - 常量定义
 * 
 * @module types/print-template/constants
 * @backend-file backend/app/Modules/Printer/Models/PrintTemplate.php
 * @author YSFL Team
 * @date 2025-11-03
 */

import {
  PrintTemplateType,
  PrintTemplateStatus,
  LabelType,
  PrintMode,
} from './enums'

// PRINT_TEMPLATE_TYPE_OPTIONS 和 getPrintTemplateTypeLabel 已在 enums.ts 中导出
// 此文件只包含 LABELS 映射和其他选项常量

/**
 * 打印模板类型映射（已废弃，使用 getPrintTemplateTypeLabel 代替）
 * @deprecated
 */
export const PRINT_TEMPLATE_TYPE_LABELS: Record<PrintTemplateType, string> = {
  [PrintTemplateType.WAREHOUSE_IN]: '入库单',
  [PrintTemplateType.WAREHOUSE_OUT]: '出库单',
  [PrintTemplateType.MATERIAL_LABEL]: '物料标签',
  [PrintTemplateType.PRODUCT_LABEL]: '产品标签',
  [PrintTemplateType.WORK_ORDER_LABEL]: '工单标签',
  [PrintTemplateType.EQUIPMENT_LABEL]: '设备标签',
  [PrintTemplateType.TOOLING_LABEL]: '工装标签',
  [PrintTemplateType.INSPECTION_LABEL]: '质检单',
  [PrintTemplateType.LOCATION_LABEL]: '货位标签',
  [PrintTemplateType.MATERIAL_LOCATION_LABEL]: '物料货位标签',
  [PrintTemplateType.NCR_ORDER]: 'NCR单',
  [PrintTemplateType.REWORK_ORDER]: '返工单',
  [PrintTemplateType.SCRAP_ORDER]: '报废单',
  [PrintTemplateType.OTHER]: '其他',
}

/**
 * 标签类型映射
 */
export const LABEL_TYPE_LABELS: Record<LabelType, string> = {
  [LabelType.GAP]: '间隙纸',
  [LabelType.BLACK_MARK]: '黑标纸',
  [LabelType.CONTINUOUS]: '连续纸',
  [LabelType.HOLE]: '定孔纸',
  [LabelType.TRANSPARENT]: '透明纸',
}

/**
 * 打印模式映射
 */
export const PRINT_MODE_LABELS: Record<PrintMode, string> = {
  [PrintMode.THERMAL]: '热敏',
  [PrintMode.THERMAL_TRANSFER]: '热转印',
}

/**
 * 打印模板状态映射
 */
export const PRINT_TEMPLATE_STATUS_LABELS: Record<PrintTemplateStatus, string> = {
  [PrintTemplateStatus.ENABLED]: '启用',
  [PrintTemplateStatus.DISABLED]: '禁用',
}

// PRINT_TEMPLATE_TYPE_OPTIONS 已从 enums 重新导出，此处删除旧定义

/**
 * 标签类型选项
 */
export const LABEL_TYPE_OPTIONS = [
  { label: '间隙纸', value: LabelType.GAP },
  { label: '黑标纸', value: LabelType.BLACK_MARK },
  { label: '连续纸', value: LabelType.CONTINUOUS },
  { label: '定孔纸', value: LabelType.HOLE },
  { label: '透明纸', value: LabelType.TRANSPARENT },
]

/**
 * 打印模式选项
 */
export const PRINT_MODE_OPTIONS = [
  { label: '热敏', value: PrintMode.THERMAL },
  { label: '热转印', value: PrintMode.THERMAL_TRANSFER },
]
